<div class="container" *ngIf="theme$ | async as theme">
  <div class="main-container-admin">
    <form class="form" [formGroup]="form" (ngOnSubmit)="onSubmit()">
      <div class="header-body box-shadow"
        [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
        <div class="title"><i class="pi pi-exclamation-circle" style="color:var(--p-red-500)"></i>
          ADMINISTRATORS ONLY
        </div>
        <p class="body">
          This section is for administrators only. Use the
          below form to enter the employee number you wish to
          emulate then click the 'Emulate' button. To return
          to your own profile, click the 'Reset' button. If you
          are not an administrator, please do not use this section and
          contact the APA help desk for assistance.
        </p>
      </div>
      <!-- Employee Number to Emulate -->
      <div class="section-title flex flex-row w-full justify-content-between">
        <div>Employee Emulator</div>
        @if(signalsService.isEumulatingEmpNumActive$()) {
        <span class="emulating-emp-num">Emulating: {{signalsService.empNumber}}</span>
        }
      </div>
      <div class="item-container">
        <div class="row">
          <input pInputText inputmode="numeric" type="text" id="employeeNumber" formControlName="employeeNumber"
            maxlength="6" (input)="numeric(form.controls.employeeNumber)" placeholder="Enter Employee Number"
            [class.ng-invalid.ng-dirty]="hasSameEmpNumAsAdmin()" [style.border-color]="form.invalid && hasSameEmpNumAsAdmin() ? 
                                   'red' : ''" required />
        </div>
        @if( hasSameEmpNumAsAdmin() ) {
        <div class="error-message">
          Employee number cannot match your own.
        </div>
        }
        @else {
        <div class="error-message"></div>
        }
      </div>
      <div class="button-container">
        <div class="row-btn">
          <button class="admin-btn box-shadow" pButton pRipple type="button"
            [disabled]="!signalsService.isEumulatingEmpNumActive$()" (click)="onReset()">
            Reset
          </button>
          <button class="admin-btn box-shadow" pButton pRipple type="submit" [disabled]="form.status === 'INVALID'"
            (click)="onSubmit()">
            Emulate
          </button>
        </div>
      </div>
    </form>
    <!-- Server Status -->
    <div class="flex flex-column w-full align-items-center justify-content-center pb-2">
      <div class="section-title flex flex-row w-full justify-content-between">
        <div class="flex flex-row gap-2 align-items-center">
          <div class="pi pi-sync sync-icon" (click)="refreshApiStatus()"></div>
          <div>Server Status</div>
        </div>
        <span>As of: {{lastUpdated}}Z</span>
      </div>
      <div class="server-container box-shadow" *ngIf="apiStatus$ | async as apiStatus; else loading">
        <div class="server-body" *ngFor="let api of apiStatus; let last = last; let first = first" 
          [style]="{'border-radius': first ? '8px 8px 0px 0px' : last ? '0px 0px 8px 8px' : '',
          'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
          <div class="flex flex-row w-full p-2 justify-content-between">
            <div class="flex flex-column">
              <div class="api-name">{{api.endpoint}}</div>
              <div class="response-time">
                Response Time: <span [style]="{'font-style': 'italic', 'width': '80px'}">
                  {{(api.endTime > 99999 ? '999+' : api.endTime < 0 ? '0' : api.endTime | number:'1.0-0')}}ms</span>
              </div>
            </div>
            <div class="flex flex-column align-items-center justify-content-center">
              <div class="flex flex-row  gap-2">
                <div class="api-status">
                  Status: <span [style]="{'color': api.status === 200 ? 'var(--p-green-500)' : 'var(--p-red-500)'}">
                    {{api.status
                    === 0 ? 'unknown' : api.status}}</span>
                </div>
                <i class="wave-icon pi pi-wave-pulse"
                  [style]="{'background': api.status === 200 ? 'var(--p-green-500)' : 'var(--p-red-500)'}"></i>
              </div>
            </div>
          </div>
          @if (!last) {
          <div class="h-divider"></div>
          }
        </div>
      </div>
      @if (!adminService.isLoadingProgressBar()) {
      <div class="flex flex-column w-full">
        <div id="placeholderDiv"></div>
      </div>
      }
      <ng-template #loading>
        <div class="server-container box-shadow">
          <div class="server-body" *ngFor="let api of ['Pilot Flight Data API', 'Crew User API', 'Member Info API', 'Pilot Flight Stats API'], 
            let i = index; let last = last; let first = first"
            [style]="{'border-radius': first ? '4px 4px 0px 0px' : last ? '0px 0px 0px 0px' : ''}">
            <div class="flex flex-row w-full p-2 justify-content-between">
              <div class="flex flex-column">
                <div class="api-name">{{api}}</div>
                <div class="response-time">Response Time: <p-skeleton width="40px" height="13px"></p-skeleton></div>
              </div>
              <div class="flex flex-column align-items-center justify-content-center">
                <div class="flex flex-row  gap-2">
                  <div class="api-status">
                    Status: <p-skeleton width="20px" height="13px"></p-skeleton>
                  </div>
                  <i class="wave-icon pi pi-wave-pulse" [style]="{'background': 'var(--gray-500)'}"></i>
                </div>
              </div>
            </div>
            @if (!last) {
            <div class="h-divider"></div>
            }
          </div>
        </div>
      </ng-template>
      @if(adminService.isLoadingProgressBar()) {
      <div class="flex flex-column w-full">
        <p-progressBar 
          [dt]="progressBar"
          mode="indeterminate"/>
      </div>
      }
    </div>
    <div class="header-body box-shadow" [style]="{'background': theme === 'light' ? 'var(--p-surface-0)' : 'var(--p-surface-50)'}">
      <div class="title"><i class="pi pi-exclamation-triangle" style="color:var(--p-red-500)"></i>
        CAUTION! Developers Only
      </div>
      <p class="body">
        Developers, please use caution when clearing any cache or logs. This action cannot be undone.
        The purpose of this section is to help with troubleshooting and should only be used by
        developers. If you are not a developer, please do not use this section and contact the APA
        help desk for assistance.
      </p>
    </div>
    <div class="section-title flex flex-row w-full justify-content-between">
      Error Logs
      <i class="pi pi-info-circle" style="color:var(--p-primary-600)" (click)="toggleErrorHelp()"></i>
    </div>
    <div class="button-container">
      <div class="row-btn">
        <button class="admin-btn box-shadow" pButton pRipple type="button" (click)="statusViewer('error')">
          Error Logs
        </button>
        <button class="admin-btn box-shadow" pButton pRipple type="submit" (click)="confirmClearLogs($event)">
          Clear Log
        </button>
      </div>
    </div>
    <!-- App Storage and Controls -->
    <div class="section-title flex flex-row w-full justify-content-between">
      App Storage
      <i class="pi pi-info-circle" style="color:var(--p-primary-600)" (click)="toggleCacheHelp()"></i>
    </div>
    <div class="button-container">
      <div class="row-btn">
        <button class="admin-btn box-shadow" pButton pRipple type="button" (click)="statusViewer('local')">
          Local Cache
        </button>
        <button class="admin-btn box-shadow" pButton pRipple type="button" (click)="statusViewer('session')">
          Session Cache
        </button>

      </div>
      <div class="row-btn">
        <button class="admin-btn box-shadow" pButton pRipple type="submit" (click)="confirmClearCache($event)">
          Clear Cache
        </button>
        <button class="admin-btn box-shadow" pButton pRipple type="submit" (click)="confirmDeleteDownloads($event)">
          Clear Export DB
        </button>
      </div>
    </div>
  </div>
</div>
<p-confirmPopup>
  <ng-template #content let-message>
    <div class="popover-row">
      <i [class]="message.icon" class="popover-icon"></i>
      <span>{{message.message}}</span>
    </div>
  </ng-template>
</p-confirmPopup>
<p-dialog header="App Storage" [modal]="true" [(visible)]="cacheInfoDialog" [style]="{ width: '25rem' }">
  <div class="error-log-container">
    <app-data-box [headerTitle]="titleLocalCache" [dataBoxItems]="localCache"></app-data-box>
    <app-data-box [headerTitle]="titleSessionCache" [dataBoxItems]="sessionCache"></app-data-box>
    <app-data-box [headerTitle]="titleClearCache" [dataBoxItems]="clearCached"></app-data-box>
    <app-data-box [headerTitle]="titleDeleteDownloads" [dataBoxItems]="deleteDownloads"></app-data-box>
  </div>
</p-dialog>
<p-dialog header="Error Logs" [modal]="true" [(visible)]="errorInfoDialog" [style]="{ width: '25rem' }">
  <div class="error-log-container">
    <app-data-box [headerTitle]="titleErrorLogs" [dataBoxItems]="errorLogs"></app-data-box>
    <app-data-box [headerTitle]="titleClearErrorLogs" [dataBoxItems]="clearError"></app-data-box>

  </div>
</p-dialog>